// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { geoSectorType_abstract } from './../abstract/SagaBase/geoSectorType_abstract';
export class geoSectorType extends geoSectorType_abstract {}
